const { REACT_APP_API_URL } = process.env;

export const main = {
  API: REACT_APP_API_URL,
  APP_NAME: 'CMS',
  LANDMARK: {
    latitude: -8.6633384,
    longitude: 115.2157072
  }
};
